import { config } from '../config.js';

/**
 * Single source of truth for the matching-week LLM provider config. Every
 * server-side call to `new AdornisLLMRouter(...)` should go through here so
 * the provider/baseURL/apiKey stay aligned.
 *
 * The endpoint must be a plain Azure OpenAI resource endpoint ending in
 * `/openai/v1`, such as `https://<resource>.openai.azure.com/openai/v1`,
 * for OpenAI-compatible chat completions.
 */
export const azureFoundryLLM = (model: 'gpt-5.6-luna' | 'gpt-5.4-mini') =>
  ({
    provider: 'openai-compatible',
    baseURL: config.get('AZURE_FOUNDRY_URL'),
    apiKey: config.get('AZURE_FOUNDRY_API_KEY'),
    model,
  }) as const;
